<template>
    <div>
      <div class="head-box" :class="{head_box_600:headBox600}">
        <div class="head-box-img">
          <img
            v-if="headBox600"
            src="~@/assets/image/bg2.jpg"
            alt=""
            :title="bannerInfo.title"
          >
          <img
            v-else
            src="~@/assets/image/body_bg.jpg"
            alt=""
            :title="bannerInfo.title"
          >
        </div>
        <div class="age_icon" @click="openMessage">
          <img src="~@/assets/image/16.png" alt="">
        </div>
        <div class="downlode_main" :class="{top_400:top_400}">
          <div class="down_desc">
            扫码下载手机客户端
          </div>
          <div class="qrcode">
            <img
              src="~@/assets/image/ewm.png"
              alt=""
            >
            <span><i></i></span>
          </div>
          <div class="downlode">
            <router-link
              href="javascript:void(0);"
              to="/download/pc"
              data-keynum="002"
            >
              <img
                src="~@/assets/image/xz_pc.png"
                alt=""
              >
            </router-link>
            <router-link
              href="javascript:void(0);"
              to="/download/mobile"
              data-keynum="002"
            >
              <img
                src="~@/assets/image/xz_android.png"
                alt=""
              >
            </router-link>
            <router-link
              href="javascript:void(0);"
              to="/download/mobile"
              data-keynum="002"
            >
              <img
                src="~@/assets/image/xz_appstore.png"
                alt=""
              >
            </router-link>
          </div>
        </div>
    </div>
    <div class="r_wk">
      <div class="rbot_dt">
        <div
          class="rob_ewm"
          style="margin-left: 56px; margin-top: 268px;"
        >
        <span><i></i></span>
        </div>
      </div>
      <div class="rbot_kk">
        <div class="rob_kftel"></div>
        <router-link
          class="rob_jyfk"
          to="/service_center/player_feedback"
        ></router-link>
      </div>
    </div>
    </div>
</template>

<script>
export default {
  props: {
    bannerInfo: Object
  },
  computed: {
    headBox600: function () {
      return this.$store.state.headBox600
    },
    top_400: function () {
      return this.$store.state.top_400
    }
  },
  methods: {
    openMessage () {
      const h = this.$createElement
      this.$msgbox({
        title: '适龄提示',
        message: h('p', null, [
          h('p', null, '提示说明： '),
          h('p', null, '1）白金岛游戏是一款玩法复杂的棋牌类游戏，适用于年满16周岁及以上用户，建议未成年人在家长下使用游戏产品。'),
          h('p', null, '2）本游戏无明显背景故事，主要玩法是各类棋类、牌类、麻将游戏，游戏为卡通风格，通过图形进行交互及音效烘托游戏氛围，游戏不存在基于文字、语音、图片等自由交流的陌生人社交系统，仅存在简单的好友系统。'),
          h('p', null, '3）本游戏中有用户实名认证系统，认证为未成年人的用户将接受以下管理：'),
          h('p', {style: 'padding-left: 20px'}, '   A、白金岛官方至尊版游戏中未满18周岁未成年人，不得参与游戏和充值。'),
          h('p', {style: 'padding-left: 20px'}, '   B、部分渠道接入国家规范的未成年防沉迷系统，未满18周岁玩家仅在周五、周六、周日和法定节假日每日20时至21时提供1小时服务。'),
          h('p', null, '4）本游戏提供的各类棋牌玩法，需要玩家在对局中进行排列组合赢得胜利，有助于玩家提高逻辑思维能力及推理判断能力。 ')
        ]),
        showCancelButton: false,
        showConfirmButton: false,
        customClass: 'slts_box',
        callback: action => {}
      })
    }
  }
}
</script>

<style>
.slts_box {
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadBox.vue